<template>
    <div class="sr-marketing-cloud-logo brand-blue">
        <div class="logo-heading">
            <span class="logo-title brand-red"> Marketing Cloud </span>
            <span class="logo-sub-title">All your marketing needs in one cloud.</span>
        </div>
        <MarketingCloudImage />
    </div>
</template>

<script>
import MarketingCloudImage from './cloud-logo-lines.svg';

export default {
    name: 'SrMarketingCloudLogo',
    components: {
        MarketingCloudImage,
    },
};
</script>
